import { Markdown } from '@cadstrom/sigma-engine-shared';

import { HilReviewTableMarkdownItem } from './hil-review-table-markdown-item.js';
import { BasicRemarkPlugin } from './markdown-plugins-utils.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown: `:hil-review-table[resultId]` */
export const HIL_REVIEW_TABLE_DIRECTIVE = 'hil-review-table';

/** Prop name that carries the stable result ID into the React component. */
const CONTENT_PROP = 'hilResultId';

/**
 * Remark plugin definition for the `hil-review-table` text directive.
 *
 * Usage in markdown: `:hil-review-table[resultId]`
 *
 * The directive renders the structured wizard HIL parse result that was registered under
 * `resultId` in the nearest {@link WizardHilContext}.
 */
export const hilReviewTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: [CONTENT_PROP],
	directive: BasicRemarkPlugin(HIL_REVIEW_TABLE_DIRECTIVE, Markdown.NodeTypes.TextDirective, {
		contentPropName: CONTENT_PROP,
	}),
	item: HilReviewTableMarkdownItem,
};
